import { showLoadingToast, closeToast } from 'vant';

export default {
  data() {
    return {
      searchForm: {},
      listPagination: {
        isListRefreshIng: false,
        isListLoading: false,
        isListFinished: false,
        isFetching: false,
        isListLoadingError: false,
        data: [],
        current: 1,
        pageSize: 20
      }
    }
  },
  methods: {
    onSearchBefore() {},
    onSearch() {
      this.onSearchBefore()
      this.onListRefresh()
    },
    fetchListData() {
      if (this.listPagination.isFetching) {
        return
      } 
      this.listPagination.isFetching = true
      const toast = showLoadingToast({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
        loadingType: "spinner",
      })
    
      let params = {
        ...this.searchForm,
        curPage: this.listPagination.current,
        length: this.listPagination.pageSize
      }
      return this.request(params)
        .then(res => {
          let resData = res.data.data
          if (!Array.isArray(resData)) {
            resData = resData.list || resData
          }
          if (this.resultDataKey) {
            resData = resData[this.resultDataKey]
          }
          if (
            this.resultDataFormatter &&
            typeof this.resultDataFormatter === 'function'
          ) {
            resData = this.resultDataFormatter(resData)
          }
          if (this.listPagination.isListRefreshIng) {
            this.listPagination.data = []
            this.listPagination.isListRefreshIng = false
          }
          if (this.listPagination.current == 1) {
            this.listPagination.data = resData
          } else {
            this.listPagination.data = this.listPagination.data.concat(resData)
          }

          if (this.listPagination.pageSize > resData.length) {
            this.listPagination.isListFinished = true
          } else {
            this.listPagination.current++
          }
        })
        .catch(() => {
          this.listPagination.isListLoadingError = true
          if (this.listPagination.isListRefreshIng) {
            this.listPagination.isListRefreshIng = false
          }
        }).finally(() => {
          if (this.listPagination.isListLoading) {
            this.listPagination.isListLoading = false
          }
          if (this.listPagination.isFetching) {
            this.listPagination.isFetching = false
          }
          
          if(toast){
            closeToast()
          }
          
          this.$emit('onListDataChange', this.listPagination.data) 
        })
    },
    onListLoad() {
      // this.listPagination.isListLoading = true
      this.fetchListData()
    },
    onListRefresh() {
      this.listPagination.current = 1
      // this.listPagination.isListRefreshIng = true
      this.listPagination.isListFinished = false
      this.listPagination.isListLoading = true
      this.fetchListData()
    },
    forceFinish() {
      this.listPagination.isListFinished = true
    },
    remove(index){
      this.listPagination.data.splice(index, 1)
    }
  }
}
